import React, { Component } from 'react'
import t from 'prop-types'

import {
  Button,
  Grid,
} from 'components/UI'
import FloorFilter from './FloorFilter'
import LineFilter from './LineFilter'

class UnitFilters extends Component {
  state = {
    floorFilter: [],
    lineFilter: [],
    filterPopupOpen: null,
  }

  handleFloorFilterSubmit = floorFilter => {
    this.setState({
      floorFilter,
    })
    this.props.onChange({
      floors: floorFilter,
      lines: this.state.lineFilter,
    })
  }

  handleLineFilterSubmit = lineFilter => {
    this.setState({
      lineFilter,
    })
    this.props.onChange({
      lines: lineFilter,
      floors: this.state.floorFilter,
    })
  }

  handleFilterClose = () => {
    this.setState({
      filterPopupOpen: null,
    })
  }

  handleFloorFilterOpen = () => {
    this.setState({
      filterPopupOpen: 'floor',
    })
  }

  handleLineFilterOpen = () => {
    this.setState({
      filterPopupOpen: 'line',
    })
  }
    
  render () {
    const {
      floorFilter,
      lineFilter,
      filterPopupOpen,
    } = this.state

    const {
      floors,
      buildingId,
    } = this.props


    return (
      <Grid.Row>
        <Grid.Col desktopOnly />
        <Grid.Col width={1.5}>
          <Grid.Row>
            <Grid.Col>
              <Button
                big
                onClick={this.handleFloorFilterOpen}
              >
                Select Floors
              </Button>
              { filterPopupOpen === 'floor' &&
                <FloorFilter
                  items={floors}
                  onSubmit={this.handleFloorFilterSubmit}
                  onClose={this.handleFilterClose}
                  selection={floorFilter}
                  buildingId={buildingId}
                />
              }
            </Grid.Col>
            <Grid.Col>
              <Button
                big
                onClick={this.handleLineFilterOpen}
              >
                Select Lines
              </Button>
              { filterPopupOpen === 'line' &&
                <LineFilter
                  items={floors}
                  onSubmit={this.handleLineFilterSubmit}
                  onClose={this.handleFilterClose}
                  selection={lineFilter}
                  buildingId={buildingId}
                />
              }
            </Grid.Col>
          </Grid.Row>
        </Grid.Col>
        <Grid.Col desktopOnly />
      </Grid.Row>
    )
  }
}

UnitFilters.propTypes = {
  buildingId: t.string.isRequired,
  onChange: t.func.isRequired,
}

export default UnitFilters



// WEBPACK FOOTER //
// ./src/components/Unit/UnitFilters.jsx